import manager from "app/module46/component-manager.js";
import Player from '@vimeo/player';

manager.register('vimeo-form', component);

/**
 * @param {HTMLFormElement} component
 * @param {Object.<string, HTMLElement>} elements
 * @param {HTMLInputElement} elements.vimeoIdField
 * @param {Object.<string, any>} attributes
 * @param {Object.<string, any>} properties
 */
function component(component, elements, attributes, properties) {
	const {vimeoIdField} = elements;


	let playerInstance;

	const url = component.action;

	const isValidHttpUrl = string => {
		let url;

		try {
			url = new URL(string);
		} catch (_) {
			return false;
		}

		return url.protocol === "http:" || url.protocol === "https:";
	};

	const updatePreview = () => {
		const id = vimeoIdField.value;

		if (id) {

			if (playerInstance) {
				playerInstance.loadVideo(id);
			} else {
				let options = {
					id,
					responsive: true
				};

				if (isValidHttpUrl(id)) {
					options = {
						url:        id,
						responsive: true
					};
				}

				playerInstance = new Player('vimeo-preview', options);
			}
		} else if (playerInstance) {
			playerInstance.destroy();
			playerInstance = null;
		}

	};

	component.addEventListener('submit', (e) => {
		e.preventDefault();

		const formData = new FormData(component);

		Swal.fire({
			position:          "bottom-end",
			loading:           true,
			showCloseButton:   false,
			showConfirmButton: false,
			toast:             true,
			customClass:       {
				popup: "panel-box"
			}
		});
		Swal.showLoading();

		manager.api(url, formData, updatePreview);
	});

	updatePreview();
}